module.exports = __webpack_public_path__ + "img/about-5.ca6fab13.webp";